var map = {
	"./LecturasCuarto/Sesion10/Lectura": [
		91012,
		9
	],
	"./LecturasCuarto/Sesion11/Lectura": [
		27545,
		9
	],
	"./LecturasCuarto/Sesion12/Lectura": [
		22106,
		9
	],
	"./LecturasCuarto/Sesion13/Lectura": [
		43135,
		9
	],
	"./LecturasCuarto/Sesion14/Lectura": [
		45424,
		9
	],
	"./LecturasCuarto/Sesion15/Lectura": [
		54981,
		9
	],
	"./LecturasCuarto/Sesion16/Lectura": [
		614,
		9
	],
	"./LecturasCuarto/Sesion17/Lectura": [
		53259,
		9
	],
	"./LecturasCuarto/Sesion18/Lectura": [
		4876,
		9
	],
	"./LecturasCuarto/Sesion19/Lectura": [
		19201,
		9
	],
	"./LecturasCuarto/Sesion20/Lectura": [
		61717,
		9
	],
	"./LecturasCuarto/Sesion21/Lectura": [
		71968,
		9
	],
	"./LecturasCuarto/Sesion22/Lectura": [
		34139,
		9
	],
	"./LecturasCuarto/Sesion23/Lectura": [
		6006,
		9
	],
	"./LecturasCuarto/Sesion24/Lectura": [
		64489,
		9
	],
	"./LecturasCuarto/Sesion25/Lectura": [
		94292,
		9
	],
	"./LecturasCuarto/Sesion26/Lectura": [
		21167,
		9
	],
	"./LecturasCuarto/Sesion27/Lectura": [
		75658,
		9
	],
	"./LecturasCuarto/Sesion28/Lectura": [
		23453,
		9
	],
	"./LecturasCuarto/Sesion29/Lectura": [
		9800,
		9
	],
	"./LecturasCuarto/Sesion3/Lectura": [
		16070,
		9
	],
	"./LecturasCuarto/Sesion30/Lectura": [
		74566,
		9
	],
	"./LecturasCuarto/Sesion31/Lectura": [
		94091,
		9
	],
	"./LecturasCuarto/Sesion32/Lectura": [
		37616,
		9
	],
	"./LecturasCuarto/Sesion33/Lectura": [
		11365,
		9
	],
	"./LecturasCuarto/Sesion34/Lectura": [
		94554,
		9
	],
	"./LecturasCuarto/Sesion35/Lectura": [
		24927,
		9
	],
	"./LecturasCuarto/Sesion36/Lectura": [
		48740,
		9
	],
	"./LecturasCuarto/Sesion37/Lectura": [
		63353,
		9
	],
	"./LecturasCuarto/Sesion38/Lectura": [
		23950,
		9
	],
	"./LecturasCuarto/Sesion39/Lectura": [
		41555,
		9
	],
	"./LecturasCuarto/Sesion4/Lectura": [
		63321,
		9
	],
	"./LecturasCuarto/Sesion40/Lectura": [
		46815,
		9
	],
	"./LecturasCuarto/Sesion41/Lectura": [
		90,
		9
	],
	"./LecturasCuarto/Sesion42/Lectura": [
		68889,
		9
	],
	"./LecturasCuarto/Sesion43/Lectura": [
		70628,
		9
	],
	"./LecturasCuarto/Sesion44/Lectura": [
		99627,
		9
	],
	"./LecturasCuarto/Sesion45/Lectura": [
		80102,
		9
	],
	"./LecturasCuarto/Sesion46/Lectura": [
		16901,
		9
	],
	"./LecturasCuarto/Sesion47/Lectura": [
		43152,
		9
	],
	"./LecturasCuarto/Sesion48/Lectura": [
		83463,
		9
	],
	"./LecturasCuarto/Sesion49/Lectura": [
		71362,
		9
	],
	"./LecturasCuarto/Sesion5/Lectura": [
		22148,
		9
	],
	"./LecturasCuarto/Sesion50/Lectura": [
		19488,
		9
	],
	"./LecturasCuarto/Sesion51/Lectura": [
		90677,
		9
	],
	"./LecturasCuarto/Sesion52/Lectura": [
		64246,
		9
	],
	"./LecturasCuarto/Sesion53/Lectura": [
		5819,
		9
	],
	"./LecturasCuarto/Sesion54/Lectura": [
		28916,
		9
	],
	"./LecturasCuarto/Sesion55/Lectura": [
		9865,
		9
	],
	"./LecturasCuarto/Sesion56/Lectura": [
		32202,
		9
	],
	"./LecturasCuarto/Sesion57/Lectura": [
		89647,
		9
	],
	"./LecturasCuarto/Sesion58/Lectura": [
		48968,
		9
	],
	"./LecturasCuarto/Sesion6/Lectura": [
		96319,
		9
	],
	"./LecturasCuarto/Sesion7/Lectura": [
		95770,
		9
	],
	"./LecturasCuarto/Sesion8/Lectura": [
		95437,
		9
	],
	"./LecturasCuarto/Sesion9/Lectura": [
		63256,
		9
	],
	"./LecturasCuarto/SesionRemedial_1/Lectura": [
		39804,
		9
	],
	"./LecturasCuarto/SesionRemedial_2/Lectura": [
		18071,
		9
	],
	"./LecturasCuarto/SesionRemedial_3/Lectura": [
		14514,
		9
	],
	"./LecturasPrimero/Sesion10/Lectura": [
		93708,
		9
	],
	"./LecturasPrimero/Sesion11/Lectura": [
		74433,
		9
	],
	"./LecturasPrimero/Sesion12/Lectura": [
		6946,
		9
	],
	"./LecturasPrimero/Sesion13/Lectura": [
		16071,
		9
	],
	"./LecturasPrimero/Sesion14/Lectura": [
		10808,
		9
	],
	"./LecturasPrimero/Sesion15/Lectura": [
		35885,
		9
	],
	"./LecturasPrimero/Sesion16/Lectura": [
		15502,
		9
	],
	"./LecturasPrimero/Sesion17/Lectura": [
		61523,
		9
	],
	"./LecturasPrimero/Sesion18/Lectura": [
		68836,
		9
	],
	"./LecturasPrimero/Sesion19/Lectura": [
		58745,
		9
	],
	"./LecturasPrimero/Sesion20/Lectura": [
		79677,
		9
	],
	"./LecturasPrimero/Sesion21/Lectura": [
		62984,
		9
	],
	"./LecturasPrimero/Sesion22/Lectura": [
		59107,
		9
	],
	"./LecturasPrimero/Sesion23/Lectura": [
		24062,
		9
	],
	"./LecturasPrimero/Sesion24/Lectura": [
		23025,
		9
	],
	"./LecturasPrimero/Sesion25/Lectura": [
		35868,
		9
	],
	"./LecturasPrimero/Sesion26/Lectura": [
		97463,
		9
	],
	"./LecturasPrimero/Sesion27/Lectura": [
		77554,
		9
	],
	"./LecturasPrimero/Sesion28/Lectura": [
		4501,
		9
	],
	"./LecturasPrimero/Sesion29/Lectura": [
		42624,
		9
	],
	"./LecturasPrimero/Sesion3/Lectura": [
		39230,
		9
	],
	"./LecturasPrimero/Sesion30/Lectura": [
		16750,
		9
	],
	"./LecturasPrimero/Sesion31/Lectura": [
		86195,
		9
	],
	"./LecturasPrimero/Sesion32/Lectura": [
		23224,
		9
	],
	"./LecturasPrimero/Sesion33/Lectura": [
		14637,
		9
	],
	"./LecturasPrimero/Sesion34/Lectura": [
		82594,
		9
	],
	"./LecturasPrimero/Sesion35/Lectura": [
		54503,
		9
	],
	"./LecturasPrimero/Sesion36/Lectura": [
		84684,
		9
	],
	"./LecturasPrimero/Sesion37/Lectura": [
		21390,
		9
	],
	"./LecturasPrimero/Sesion38/Lectura": [
		80422,
		9
	],
	"./LecturasPrimero/Sesion39/Lectura": [
		16715,
		9
	],
	"./LecturasPrimero/Sesion4/Lectura": [
		3569,
		9
	],
	"./LecturasPrimero/Sesion40/Lectura": [
		60039,
		9
	],
	"./LecturasPrimero/Sesion41/Lectura": [
		88130,
		9
	],
	"./LecturasPrimero/Sesion42/Lectura": [
		4545,
		9
	],
	"./LecturasPrimero/Sesion43/Lectura": [
		90220,
		9
	],
	"./LecturasPrimero/Sesion44/Lectura": [
		8083,
		9
	],
	"./LecturasPrimero/Sesion45/Lectura": [
		22286,
		9
	],
	"./LecturasPrimero/Sesion46/Lectura": [
		20173,
		9
	],
	"./LecturasPrimero/Sesion47/Lectura": [
		28760,
		9
	],
	"./LecturasPrimero/Sesion48/Lectura": [
		28479,
		9
	],
	"./LecturasPrimero/Sesion49/Lectura": [
		7450,
		9
	],
	"./LecturasPrimero/Sesion5/Lectura": [
		80796,
		9
	],
	"./LecturasPrimero/Sesion50/Lectura": [
		95144,
		9
	],
	"./LecturasPrimero/Sesion51/Lectura": [
		8797,
		9
	],
	"./LecturasPrimero/Sesion52/Lectura": [
		38910,
		9
	],
	"./LecturasPrimero/Sesion53/Lectura": [
		75619,
		9
	],
	"./LecturasPrimero/Sesion54/Lectura": [
		53756,
		9
	],
	"./LecturasPrimero/Sesion55/Lectura": [
		98737,
		9
	],
	"./LecturasPrimero/Sesion56/Lectura": [
		28466,
		9
	],
	"./LecturasPrimero/Sesion57/Lectura": [
		32023,
		9
	],
	"./LecturasPrimero/Sesion58/Lectura": [
		57312,
		9
	],
	"./LecturasPrimero/Sesion59/Lectura": [
		47061,
		7,
		47061
	],
	"./LecturasPrimero/Sesion6/Lectura": [
		34327,
		9
	],
	"./LecturasPrimero/Sesion7/Lectura": [
		14962,
		9
	],
	"./LecturasPrimero/Sesion8/Lectura": [
		48629,
		9
	],
	"./LecturasPrimero/Sesion9/Lectura": [
		22880,
		9
	],
	"./LecturasPrimero/SesionRemedial_1/Lectura": [
		12356,
		9
	],
	"./LecturasPrimero/SesionRemedial_2/Lectura": [
		64479,
		9
	],
	"./LecturasPrimero/SesionRemedial_3/Lectura": [
		27098,
		9
	],
	"./LecturasQuinto/Sesion10/Lectura": [
		93134,
		9
	],
	"./LecturasQuinto/Sesion11/Lectura": [
		39155,
		9
	],
	"./LecturasQuinto/Sesion12/Lectura": [
		88440,
		9
	],
	"./LecturasQuinto/Sesion13/Lectura": [
		13517,
		9
	],
	"./LecturasQuinto/Sesion14/Lectura": [
		84578,
		9
	],
	"./LecturasQuinto/Sesion15/Lectura": [
		93703,
		9
	],
	"./LecturasQuinto/Sesion16/Lectura": [
		71340,
		9
	],
	"./LecturasQuinto/Sesion17/Lectura": [
		52065,
		9
	],
	"./LecturasQuinto/Sesion18/Lectura": [
		76198,
		9
	],
	"./LecturasQuinto/Sesion19/Lectura": [
		40043,
		9
	],
	"./LecturasQuinto/Sesion20/Lectura": [
		29947,
		9
	],
	"./LecturasQuinto/Sesion21/Lectura": [
		88374,
		9
	],
	"./LecturasQuinto/Sesion22/Lectura": [
		14805,
		9
	],
	"./LecturasQuinto/Sesion23/Lectura": [
		43616,
		9
	],
	"./LecturasQuinto/Sesion24/Lectura": [
		13775,
		9
	],
	"./LecturasQuinto/Sesion25/Lectura": [
		56330,
		9
	],
	"./LecturasQuinto/Sesion26/Lectura": [
		33993,
		9
	],
	"./LecturasQuinto/Sesion27/Lectura": [
		53044,
		9
	],
	"./LecturasQuinto/Sesion28/Lectura": [
		40259,
		9
	],
	"./LecturasQuinto/Sesion29/Lectura": [
		47966,
		9
	],
	"./LecturasQuinto/Sesion3/Lectura": [
		77640,
		9
	],
	"./LecturasQuinto/Sesion30/Lectura": [
		92780,
		9
	],
	"./LecturasQuinto/Sesion31/Lectura": [
		93409,
		9
	],
	"./LecturasQuinto/Sesion32/Lectura": [
		66530,
		9
	],
	"./LecturasQuinto/Sesion33/Lectura": [
		7655,
		9
	],
	"./LecturasQuinto/Sesion34/Lectura": [
		43800,
		9
	],
	"./LecturasQuinto/Sesion35/Lectura": [
		75981,
		9
	],
	"./LecturasQuinto/Sesion36/Lectura": [
		97582,
		9
	],
	"./LecturasQuinto/Sesion37/Lectura": [
		96403,
		9
	],
	"./LecturasQuinto/Sesion38/Lectura": [
		2692,
		9
	],
	"./LecturasQuinto/Sesion39/Lectura": [
		43865,
		9
	],
	"./LecturasQuinto/Sesion4/Lectura": [
		67511,
		9
	],
	"./LecturasQuinto/Sesion40/Lectura": [
		94153,
		9
	],
	"./LecturasQuinto/Sesion41/Lectura": [
		23956,
		9
	],
	"./LecturasQuinto/Sesion42/Lectura": [
		67183,
		9
	],
	"./LecturasQuinto/Sesion43/Lectura": [
		21674,
		9
	],
	"./LecturasQuinto/Sesion44/Lectura": [
		91381,
		9
	],
	"./LecturasQuinto/Sesion45/Lectura": [
		17984,
		9
	],
	"./LecturasQuinto/Sesion46/Lectura": [
		63803,
		9
	],
	"./LecturasQuinto/Sesion47/Lectura": [
		52022,
		9
	],
	"./LecturasQuinto/Sesion48/Lectura": [
		59409,
		9
	],
	"./LecturasQuinto/Sesion49/Lectura": [
		98076,
		9
	],
	"./LecturasQuinto/Sesion5/Lectura": [
		36530,
		9
	],
	"./LecturasQuinto/Sesion50/Lectura": [
		40570,
		9
	],
	"./LecturasQuinto/Sesion51/Lectura": [
		70943,
		9
	],
	"./LecturasQuinto/Sesion52/Lectura": [
		94756,
		9
	],
	"./LecturasQuinto/Sesion53/Lectura": [
		93017,
		9
	],
	"./LecturasQuinto/Sesion54/Lectura": [
		20582,
		9
	],
	"./LecturasQuinto/Sesion55/Lectura": [
		23755,
		9
	],
	"./LecturasQuinto/Sesion56/Lectura": [
		83632,
		9
	],
	"./LecturasQuinto/Sesion57/Lectura": [
		57381,
		9
	],
	"./LecturasQuinto/Sesion58/Lectura": [
		11842,
		9
	],
	"./LecturasQuinto/Sesion59/Lectura": [
		7591,
		7,
		7591
	],
	"./LecturasQuinto/Sesion6/Lectura": [
		35537,
		9
	],
	"./LecturasQuinto/Sesion7/Lectura": [
		31388,
		9
	],
	"./LecturasQuinto/Sesion8/Lectura": [
		18139,
		9
	],
	"./LecturasQuinto/Sesion9/Lectura": [
		76566,
		9
	],
	"./LecturasQuinto/SesionRemedial_1/Lectura": [
		83190,
		9
	],
	"./LecturasQuinto/SesionRemedial_2/Lectura": [
		12245,
		9
	],
	"./LecturasQuinto/SesionRemedial_3/Lectura": [
		70144,
		9
	],
	"./LecturasSegundo/Sesion10/Lectura": [
		93063,
		9
	],
	"./LecturasSegundo/Sesion11/Lectura": [
		80962,
		9
	],
	"./LecturasSegundo/Sesion12/Lectura": [
		92705,
		9
	],
	"./LecturasSegundo/Sesion13/Lectura": [
		92204,
		9
	],
	"./LecturasSegundo/Sesion14/Lectura": [
		73043,
		9
	],
	"./LecturasSegundo/Sesion15/Lectura": [
		39086,
		9
	],
	"./LecturasSegundo/Sesion16/Lectura": [
		37325,
		9
	],
	"./LecturasSegundo/Sesion17/Lectura": [
		96600,
		9
	],
	"./LecturasSegundo/Sesion18/Lectura": [
		40063,
		9
	],
	"./LecturasSegundo/Sesion19/Lectura": [
		9690,
		9
	],
	"./LecturasSegundo/Sesion20/Lectura": [
		83962,
		9
	],
	"./LecturasSegundo/Sesion21/Lectura": [
		78015,
		9
	],
	"./LecturasSegundo/Sesion22/Lectura": [
		98628,
		9
	],
	"./LecturasSegundo/Sesion23/Lectura": [
		88537,
		9
	],
	"./LecturasSegundo/Sesion24/Lectura": [
		28358,
		9
	],
	"./LecturasSegundo/Sesion25/Lectura": [
		92203,
		9
	],
	"./LecturasSegundo/Sesion26/Lectura": [
		13648,
		9
	],
	"./LecturasSegundo/Sesion27/Lectura": [
		3749,
		9
	],
	"./LecturasSegundo/Sesion28/Lectura": [
		36738,
		9
	],
	"./LecturasSegundo/Sesion29/Lectura": [
		45863,
		9
	],
	"./LecturasSegundo/Sesion3/Lectura": [
		94455,
		9
	],
	"./LecturasSegundo/Sesion30/Lectura": [
		86409,
		9
	],
	"./LecturasSegundo/Sesion31/Lectura": [
		41044,
		9
	],
	"./LecturasSegundo/Sesion32/Lectura": [
		84783,
		9
	],
	"./LecturasSegundo/Sesion33/Lectura": [
		23754,
		9
	],
	"./LecturasSegundo/Sesion34/Lectura": [
		30677,
		9
	],
	"./LecturasSegundo/Sesion35/Lectura": [
		4928,
		9
	],
	"./LecturasSegundo/Sesion36/Lectura": [
		91931,
		9
	],
	"./LecturasSegundo/Sesion37/Lectura": [
		17974,
		9
	],
	"./LecturasSegundo/Sesion38/Lectura": [
		85617,
		9
	],
	"./LecturasSegundo/Sesion39/Lectura": [
		46492,
		9
	],
	"./LecturasSegundo/Sesion4/Lectura": [
		76328,
		9
	],
	"./LecturasSegundo/Sesion40/Lectura": [
		14476,
		9
	],
	"./LecturasSegundo/Sesion41/Lectura": [
		28801,
		9
	],
	"./LecturasSegundo/Sesion42/Lectura": [
		12386,
		9
	],
	"./LecturasSegundo/Sesion43/Lectura": [
		84295,
		9
	],
	"./LecturasSegundo/Sesion44/Lectura": [
		53016,
		9
	],
	"./LecturasSegundo/Sesion45/Lectura": [
		44429,
		9
	],
	"./LecturasSegundo/Sesion46/Lectura": [
		46542,
		9
	],
	"./LecturasSegundo/Sesion47/Lectura": [
		15987,
		9
	],
	"./LecturasSegundo/Sesion48/Lectura": [
		612,
		9
	],
	"./LecturasSegundo/Sesion49/Lectura": [
		37145,
		9
	],
	"./LecturasSegundo/Sesion5/Lectura": [
		76669,
		9
	],
	"./LecturasSegundo/Sesion50/Lectura": [
		11003,
		9
	],
	"./LecturasSegundo/Sesion51/Lectura": [
		12086,
		9
	],
	"./LecturasSegundo/Sesion52/Lectura": [
		34293,
		9
	],
	"./LecturasSegundo/Sesion53/Lectura": [
		72416,
		9
	],
	"./LecturasSegundo/Sesion54/Lectura": [
		22223,
		9
	],
	"./LecturasSegundo/Sesion55/Lectura": [
		80010,
		9
	],
	"./LecturasSegundo/Sesion56/Lectura": [
		60297,
		9
	],
	"./LecturasSegundo/Sesion57/Lectura": [
		18900,
		9
	],
	"./LecturasSegundo/Sesion58/Lectura": [
		88899,
		9
	],
	"./LecturasSegundo/Sesion6/Lectura": [
		21054,
		9
	],
	"./LecturasSegundo/Sesion7/Lectura": [
		56099,
		9
	],
	"./LecturasSegundo/Sesion8/Lectura": [
		63719,
		9
	],
	"./LecturasSegundo/Sesion9/Lectura": [
		43849,
		9
	],
	"./LecturasSegundo/SesionRemedial_1/Lectura": [
		74727,
		9
	],
	"./LecturasSegundo/SesionRemedial_2/Lectura": [
		21260,
		9
	],
	"./LecturasSegundo/SesionRemedial_3/Lectura": [
		19233,
		9
	],
	"./LecturasSexto/Sesion10/Lectura": [
		84793,
		9
	],
	"./LecturasSexto/Sesion11/Lectura": [
		70180,
		9
	],
	"./LecturasSexto/Sesion12/Lectura": [
		46367,
		9
	],
	"./LecturasSexto/Sesion13/Lectura": [
		15994,
		9
	],
	"./LecturasSexto/Sesion14/Lectura": [
		32805,
		9
	],
	"./LecturasSexto/Sesion15/Lectura": [
		59056,
		9
	],
	"./LecturasSexto/Sesion16/Lectura": [
		99179,
		9
	],
	"./LecturasSexto/Sesion17/Lectura": [
		96006,
		9
	],
	"./LecturasSexto/Sesion18/Lectura": [
		99009,
		9
	],
	"./LecturasSexto/Sesion19/Lectura": [
		98508,
		9
	],
	"./LecturasSexto/Sesion20/Lectura": [
		98168,
		9
	],
	"./LecturasSexto/Sesion21/Lectura": [
		73229,
		9
	],
	"./LecturasSexto/Sesion22/Lectura": [
		75342,
		9
	],
	"./LecturasSexto/Sesion23/Lectura": [
		61139,
		9
	],
	"./LecturasSexto/Sesion24/Lectura": [
		59628,
		9
	],
	"./LecturasSexto/Sesion25/Lectura": [
		57601,
		9
	],
	"./LecturasSexto/Sesion26/Lectura": [
		41186,
		9
	],
	"./LecturasSexto/Sesion27/Lectura": [
		13095,
		9
	],
	"./LecturasSexto/Sesion28/Lectura": [
		83824,
		9
	],
	"./LecturasSexto/Sesion29/Lectura": [
		93381,
		9
	],
	"./LecturasSexto/Sesion3/Lectura": [
		40385,
		9
	],
	"./LecturasSexto/Sesion30/Lectura": [
		56055,
		9
	],
	"./LecturasSexto/Sesion31/Lectura": [
		52498,
		9
	],
	"./LecturasSexto/Sesion32/Lectura": [
		81617,
		9
	],
	"./LecturasSexto/Sesion33/Lectura": [
		10812,
		9
	],
	"./LecturasSexto/Sesion34/Lectura": [
		17699,
		9
	],
	"./LecturasSexto/Sesion35/Lectura": [
		82654,
		9
	],
	"./LecturasSexto/Sesion36/Lectura": [
		38269,
		9
	],
	"./LecturasSexto/Sesion37/Lectura": [
		37928,
		9
	],
	"./LecturasSexto/Sesion38/Lectura": [
		67375,
		9
	],
	"./LecturasSexto/Sesion39/Lectura": [
		25162,
		9
	],
	"./LecturasSexto/Sesion4/Lectura": [
		58126,
		9
	],
	"./LecturasSexto/Sesion40/Lectura": [
		77118,
		9
	],
	"./LecturasSexto/Sesion41/Lectura": [
		12163,
		9
	],
	"./LecturasSexto/Sesion42/Lectura": [
		32392,
		9
	],
	"./LecturasSexto/Sesion43/Lectura": [
		32733,
		9
	],
	"./LecturasSexto/Sesion44/Lectura": [
		30610,
		9
	],
	"./LecturasSexto/Sesion45/Lectura": [
		50519,
		9
	],
	"./LecturasSexto/Sesion46/Lectura": [
		88924,
		9
	],
	"./LecturasSexto/Sesion47/Lectura": [
		76081,
		9
	],
	"./LecturasSexto/Sesion48/Lectura": [
		35350,
		9
	],
	"./LecturasSexto/Sesion49/Lectura": [
		34267,
		9
	],
	"./LecturasSexto/Sesion5/Lectura": [
		27571,
		9
	],
	"./LecturasSexto/Sesion50/Lectura": [
		88941,
		9
	],
	"./LecturasSexto/Sesion51/Lectura": [
		63864,
		9
	],
	"./LecturasSexto/Sesion52/Lectura": [
		14579,
		9
	],
	"./LecturasSexto/Sesion53/Lectura": [
		68558,
		9
	],
	"./LecturasSexto/Sesion54/Lectura": [
		27489,
		9
	],
	"./LecturasSexto/Sesion55/Lectura": [
		46764,
		9
	],
	"./LecturasSexto/Sesion56/Lectura": [
		69127,
		9
	],
	"./LecturasSexto/Sesion57/Lectura": [
		60002,
		9
	],
	"./LecturasSexto/Sesion58/Lectura": [
		27013,
		9
	],
	"./LecturasSexto/Sesion59/Lectura": [
		36912,
		7,
		36912
	],
	"./LecturasSexto/Sesion6/Lectura": [
		64600,
		9
	],
	"./LecturasSexto/Sesion7/Lectura": [
		56013,
		9
	],
	"./LecturasSexto/Sesion8/Lectura": [
		43290,
		9
	],
	"./LecturasSexto/Sesion9/Lectura": [
		64319,
		9
	],
	"./LecturasSexto/SesionRemedial_1/Lectura": [
		16366,
		9
	],
	"./LecturasSexto/SesionRemedial_2/Lectura": [
		93922,
		9
	],
	"./LecturasSexto/SesionRemedial_3/Lectura": [
		49479,
		9
	],
	"./LecturasTercero/Sesion10/Lectura": [
		79588,
		9
	],
	"./LecturasTercero/Sesion11/Lectura": [
		20761,
		9
	],
	"./LecturasTercero/Sesion12/Lectura": [
		69562,
		9
	],
	"./LecturasTercero/Sesion13/Lectura": [
		92492,
		9
	],
	"./LecturasTercero/Sesion14/Lectura": [
		68368,
		9
	],
	"./LecturasTercero/Sesion15/Lectura": [
		25957,
		9
	],
	"./LecturasTercero/Sesion16/Lectura": [
		89862,
		9
	],
	"./LecturasTercero/Sesion17/Lectura": [
		63736,
		9
	],
	"./LecturasTercero/Sesion18/Lectura": [
		69676,
		9
	],
	"./LecturasTercero/Sesion19/Lectura": [
		86657,
		9
	],
	"./LecturasTercero/Sesion20/Lectura": [
		71765,
		9
	],
	"./LecturasTercero/Sesion21/Lectura": [
		29664,
		9
	],
	"./LecturasTercero/Sesion22/Lectura": [
		33019,
		9
	],
	"./LecturasTercero/Sesion23/Lectura": [
		59062,
		9
	],
	"./LecturasTercero/Sesion24/Lectura": [
		27497,
		9
	],
	"./LecturasTercero/Sesion25/Lectura": [
		82132,
		9
	],
	"./LecturasTercero/Sesion26/Lectura": [
		9519,
		9
	],
	"./LecturasTercero/Sesion27/Lectura": [
		64842,
		9
	],
	"./LecturasTercero/Sesion28/Lectura": [
		66557,
		9
	],
	"./LecturasTercero/Sesion29/Lectura": [
		13384,
		9
	],
	"./LecturasTercero/Sesion3/Lectura": [
		29446,
		9
	],
	"./LecturasTercero/Sesion30/Lectura": [
		69446,
		9
	],
	"./LecturasTercero/Sesion31/Lectura": [
		16939,
		9
	],
	"./LecturasTercero/Sesion32/Lectura": [
		38384,
		9
	],
	"./LecturasTercero/Sesion33/Lectura": [
		28485,
		9
	],
	"./LecturasTercero/Sesion34/Lectura": [
		25050,
		9
	],
	"./LecturasTercero/Sesion35/Lectura": [
		19103,
		9
	],
	"./LecturasTercero/Sesion36/Lectura": [
		23364,
		9
	],
	"./LecturasTercero/Sesion37/Lectura": [
		29625,
		9
	],
	"./LecturasTercero/Sesion38/Lectura": [
		70030,
		9
	],
	"./LecturasTercero/Sesion39/Lectura": [
		32403,
		9
	],
	"./LecturasTercero/Sesion4/Lectura": [
		56377,
		9
	],
	"./LecturasTercero/Sesion40/Lectura": [
		24639,
		9
	],
	"./LecturasTercero/Sesion41/Lectura": [
		30586,
		9
	],
	"./LecturasTercero/Sesion42/Lectura": [
		35161,
		9
	],
	"./LecturasTercero/Sesion43/Lectura": [
		45252,
		9
	],
	"./LecturasTercero/Sesion44/Lectura": [
		38827,
		9
	],
	"./LecturasTercero/Sesion45/Lectura": [
		74982,
		9
	],
	"./LecturasTercero/Sesion46/Lectura": [
		50373,
		9
	],
	"./LecturasTercero/Sesion47/Lectura": [
		43920,
		9
	],
	"./LecturasTercero/Sesion48/Lectura": [
		92487,
		9
	],
	"./LecturasTercero/Sesion49/Lectura": [
		83362,
		9
	],
	"./LecturasTercero/Sesion5/Lectura": [
		36196,
		9
	],
	"./LecturasTercero/Sesion50/Lectura": [
		19040,
		9
	],
	"./LecturasTercero/Sesion51/Lectura": [
		80917,
		9
	],
	"./LecturasTercero/Sesion52/Lectura": [
		42358,
		9
	],
	"./LecturasTercero/Sesion53/Lectura": [
		57627,
		9
	],
	"./LecturasTercero/Sesion54/Lectura": [
		49172,
		9
	],
	"./LecturasTercero/Sesion55/Lectura": [
		6921,
		9
	],
	"./LecturasTercero/Sesion56/Lectura": [
		26634,
		9
	],
	"./LecturasTercero/Sesion57/Lectura": [
		68847,
		9
	],
	"./LecturasTercero/Sesion58/Lectura": [
		39400,
		9
	],
	"./LecturasTercero/Sesion6/Lectura": [
		88319,
		9
	],
	"./LecturasTercero/Sesion7/Lectura": [
		50938,
		9
	],
	"./LecturasTercero/Sesion8/Lectura": [
		63661,
		9
	],
	"./LecturasTercero/Sesion9/Lectura": [
		88600,
		9
	],
	"./LecturasTercero/SesionRemedial_1/Lectura": [
		58940,
		9
	],
	"./LecturasTercero/SesionRemedial_2/Lectura": [
		28823,
		9
	],
	"./LecturasTercero/SesionRemedial_3/Lectura": [
		9458,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73787;
module.exports = webpackAsyncContext;